'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import AppLink from '@/components/elementary/AppLink';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import type { GridCategoryNavigationData } from '@/types/general';
export function SidePanelCategoryNavigation(t0) {
  const $ = _c(23);
  const {
    topCategories,
    restCategories,
    additionalLink,
    categorySlug
  } = t0;
  const t = useTranslations("CategoryNavigation");
  let t1;
  if ($[0] !== categorySlug) {
    t1 = slug => {
      if (categorySlug === null && slug === null) {
        return true;
      }
      return slug === categorySlug;
    };
    $[0] = categorySlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActive = t1;
  let t2;
  if ($[2] !== isActive || $[3] !== topCategories) {
    t2 = Array.isArray(topCategories) && topCategories?.length > 0 ? <nav><ul className="flex flex-col gap-3">{topCategories?.map(category => <li key={category.documentId}><AppLink size="none" variant="ghost" href={category.link} scroll={false} className={cn("flex justify-start", isActive(category.slug) && "text-brand-salmon font-bold")}>{category?.title}</AppLink></li>)}</ul></nav> : null;
    $[2] = isActive;
    $[3] = topCategories;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Paragraph fontSize="headingSmall">{t3}</Paragraph>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isActive || $[10] !== restCategories) {
    t5 = restCategories?.map(category_0 => <li key={category_0.documentId}><AppLink size="none" variant="ghost" href={category_0.link} scroll={false} className={cn("flex justify-start", isActive(category_0.slug) && "text-brand-salmon font-bold")}>{category_0?.title}</AppLink></li>);
    $[9] = isActive;
    $[10] = restCategories;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <nav><ul className="flex flex-col gap-3">{t5}</ul></nav>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t4}{t6}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== additionalLink) {
    t8 = additionalLink?.href && <div className="border-t border-neutral-light-40 pt-9"><AppLink link={additionalLink} size="none" variant="ghost">{additionalLink.label}</AppLink></div>;
    $[17] = additionalLink;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="lg:flex hidden flex-col gap-8 w-full lg:max-w-74.5">{t2}{t7}{t8}</div>;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}